<template>
  <ContentBox title="New User">
    <template v-slot:content>
      <FormGroup v-bind:form="userForm">
        <FormRow label="Email"><FormInputText v-model="user.email" field="email" /></FormRow>
        <FormRow label="Password"><FormInputText type="password" v-model="user.password" field="password" /></FormRow>
        <FormRow label="Confirm Password"><FormInputText type="password" v-model="user.confirmPassword" field="confirmPassword" /></FormRow>
        <FormHorizontalRule />
        <FormRow label="Title"><FormSelect v-model="user.title" field="title" :options="titleOptions" /></FormRow>
        <FormRow label="Name"><FormInputText v-model="user.name" field="name" /></FormRow>
        <FormRow label="Phone"><FormInputText v-model="user.phone" field="phone" /></FormRow>
        <FormRow label="Mobile"><FormInputText v-model="user.mobile" field="mobile" /></FormRow>
        <FormRow label="Timezone Code">
          <FormSearchableSelect :options="timezoneCodeList" placeholder="Timezone" v-model="user.timezoneCode" field="timezoneCode" />
        </FormRow>
        <FormRow label="Date Of Birth"><FormDate v-model="user.dateOfBirth" field="dateOfBirth" /></FormRow>
        <FormRow label="Highlight Colour" helpTip="Highlight colour for the user used in the calendar and maps for task management">
          <FormColourTag v-model="user.highlightColour" field="highlightColour" />
        </FormRow>
        <FormRow label="Labels"><FormLabelTag popupName="User Labels" v-model="user.labelList" labelType="user" field="labelList" /></FormRow>
        <FormHorizontalRule />
        <FormRow label="User Groups"><FormMultiSelect @input="user.userGroups = $event" :options="userGroupList" :loading="userGroupListLoading" placeholder="Select User Groups" /></FormRow>
        <FormSubmit label="Create" :submitting="submitting" @submitted="createUser" @cancelled="cancelCreateUser" />
      </FormGroup>
    </template>
  </ContentBox>
</template>

<script>
import _ from 'lodash'
import moment from 'moment-timezone'

import form from '@/mixins/form'
import { PersonTitleLookup } from '@/store/types'

export default {
  name: "UserNew",
  mixins: [form],
  components: {
  },
  data: () => {
    return {
      breadcrumbs: [
        { title: "Users", link: "/users" },
        { title: "Users" }
      ],
      user: {
        labelList: [],
        highlightColour: null
      },
      userForm: {},
      submitting: false,
      titleOptions: PersonTitleLookup,
      userGroupList: [],
      userGroupListLoading: false,
      timezoneCodeList: []
    };
  },
  mounted() {
    this.timezoneCodeList = moment.tz.names().map(tz => { return { name: tz, value: tz } })

    // Default timezone
    this.user.timezoneCode = moment.tz.guess()

    // Get User Group list
    // FUTURE: Somehow send a promise to the select component. It can handle loading state based on promise
    this.userGroupListLoading = true
    this.$apiService.userService.getUserGroupList()
    .then(list => {
      this.userGroupList = list.data.map(userGroupInfo => {
        return {
          value: userGroupInfo.id,
          name: userGroupInfo.name,
          colour: userGroupInfo.colourTag
        }
      })
      this.userGroupListLoading = false
    })
  },
  methods: {
    createUser() {
      this.submitting = true

      var userData = _.cloneDeep(this.$data.user)
      userData.labelList = userData.labelList.map(label => label.id)

      this.$data.userForm = this.clearFormResponse()

      this.$apiService.userService.createUser(userData)
      .then(response => {
          this.submitting = false

          this.successToast('User Created')
          this.$router.push(`/users/${response.data.id}`)
      })
      .catch(err => {
          // Process errors
          this.$data.userForm = this.processFormResponse(err)

          this.submitting = false
      })
    },
    cancelCreateUser() {
      this.$router.push('/users')
    }
  }
}

</script>